var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelosNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5465 14.1301C35.5465 9.60534 38.8847 6.26025 43.313 6.26025C47.7414 6.26025 51.0484 9.63155 51.0484 14.1301C51.0484 18.6287 47.7362 22 43.2819 22C38.8275 22 35.5465 18.6864 35.5465 14.1301ZM48.7382 14.1301C48.7382 10.8165 46.4851 8.33651 43.2871 8.33651C40.0891 8.33651 37.8619 10.8427 37.8619 14.1301C37.8619 17.4175 40.115 19.9237 43.2871 19.9237C46.4591 19.9237 48.7382 17.4752 48.7382 14.1301Z",
    fill: "url(#paint0_linear_224_2092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79824 17.0977V8.56196H0V6.63251H2.22717C2.62692 6.63251 2.9436 6.37035 2.9436 5.88275V2.28074H5.05656V6.63251H9.62512V8.56196H5.05656V17.0663C5.05656 18.6811 5.65878 19.6301 7.3668 19.6301H9.42265V21.6173H7.22662C4.48549 21.6173 2.80343 20.1177 2.80343 17.0925L2.79824 17.0977ZM11.9042 14.1301C11.9042 9.34318 15.1282 6.26025 19.1827 6.26025C23.6942 6.26025 26.3782 9.60534 26.3782 13.9309V14.9376H14.2715C14.3858 17.9366 16.2962 19.9237 19.3541 19.9237C21.3217 19.9237 23.2062 18.9747 23.8915 17.2131H26.2329C25.4074 20.0076 22.8064 22 19.3229 22C14.7855 22 11.899 18.6287 11.899 14.1301H11.9042ZM23.9849 12.919C23.7824 9.91992 21.7006 8.33651 19.1879 8.33651C16.6752 8.33651 14.5623 10.1506 14.3338 12.919H23.9849ZM29.5243 18.4242V0H31.7774V18.4242C31.7774 19.174 32.146 19.6039 32.8625 19.6039H33.5477V21.6225H32.4627C30.6041 21.6225 29.5191 20.469 29.5191 18.4242H29.5243ZM53.6234 17.2707H55.8246C56.079 19.0586 57.3354 20.0076 59.5054 20.0076C61.6755 20.0076 62.9578 18.9118 62.9578 17.3861C62.9578 13.1759 54.0803 16.3794 54.0803 10.439C54.0803 7.90133 56.3334 6.26025 59.4483 6.26025C62.1895 6.26025 64.4737 7.87512 64.7022 10.5858H62.5321C62.3348 9.17016 61.2758 8.22116 59.3082 8.22116C57.4496 8.22116 56.2555 9.14395 56.2555 10.439C56.2555 14.2455 65.1642 11.0734 65.1642 17.2707C65.1642 20.0968 62.8488 22 59.3964 22C55.944 22 53.8882 20.0705 53.6286 17.2707H53.6234Z",
    fill: "#2C2B2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_2092",
    x1: 37.62,
    y1: 8.58002,
    x2: 48.18,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#4FACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#C471F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_2092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.1538,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelosNew);
export default __webpack_public_path__ + "static/media/telos-new.cfb9d64f0a8abbc9800b8cd03915dcc9.svg";
export { ForwardRef as ReactComponent };